import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LifeEventRow from './LifeEventRow';
import { deepEqual } from '../../utils';

class LifeEventsTable extends Component {
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  getEventsRows() {
    return this.props.events.map((event, index) => (
      <LifeEventRow
        key={event.id}
        event={event}
        isLast={index === 0}
        onDelete={this.props.onDelete}
      />
    ));
  }

  render() {
    return (
      <table className="events-table">
        <thead>
          <tr>
            <th>Iniciado em</th>
            <th>Evento</th>
            <th className="align-right">Duração</th>
            <th className="align-right">Ac. Trab</th>
            <th className="align-right">Ac. Folga</th>
          </tr>
        </thead>
        <tbody>
          {this.getEventsRows()}
        </tbody>
      </table>
    );
  }
}

LifeEventsTable.propTypes = {
  events: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default LifeEventsTable;



// WEBPACK FOOTER //
// ./src/Driver/DriverLifeEventsPopup/LifeEventsTable.js